import endpointDuckFactory from "./_endpointDuckFactory";

export const regionsDuck = endpointDuckFactory({ endpoint: "regions" });
